<p-fluid>
  <div
    [class.xofmanyrequired]="xOfManyErrors() && isOneOfManyRequired()"
    class="w-100"
  >
    <p-multiSelect
      #communitySelection="ngModel"
      name="communitySelection"
      [options]="communityOptions"
      [required]="required()"
      [(ngModel)]="selectedCommunities"
      (onPanelHide)="onPanelHide()"
      resetFilterOnHide="true"
      [placeholder]="label"
      selectedItemsLabel="{0} items selected"
      [maxSelectedLabels]="maxSelectedLabels()"
      [showToggleAll]="showToggleAll()"
      [selectionLimit]="selectionLimit()"
      [disabled]="disabled"
      [appendTo]="appendTo()"
    />
  </div>
  <error-message [errorControl]="communitySelection">
    @if (communitySelection?.errors?.required) {
      <span>Please select at least one community to continue.</span>
    }
  </error-message>
</p-fluid>
